import { useDispatch, useSelector } from 'react-redux';
import { changeLeaveStatus, changeStatus, getClassSchedules, getClassStudents, getFacultyList, getSubjects, markAbsent, markAttendance, markPresent } from '../../Redux/ActionCreators/scheduleAction';
import React, { useEffect, useState } from 'react';
import { Table } from "react-bootstrap";
import "./attendance.scss";
import Modal from "react-bootstrap/Modal";
import Switch from "react-switch";
import Select from 'react-select';
import { getChapters, getTopics } from '../../Redux/ActionCreators/manageContentAction';
import { convertDate, formatTimeTo12Hour } from '../../utils/miscelleneous';

function Attendance() {
    const [scheduleSearch, setScheduleSearch] = useState('');
    const [studentSearch, setStudentSearch] = useState('');
    const [isMark, setIsMark] = useState(false);
    const [classId, setClassId] = useState('');
    const [isWarn, setIswarn] = useState(false);
    const [save, setSave] = useState(false);
    const [isOpenFilter, setIsOpenFilter] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedChapter, setSelectedChapter] = useState(null);
    const [selectedTopic, setSelectedTopic] = useState(null);
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [selectedFaculty, setSelectedFaculty] = useState(null);
    const [subjectId, setSubjectId] = useState('');
    const [chapterId, setChapterId] = useState('');
    const [topicId, setTopicId] = useState('');
    const [facultyId, setFacultyId] = useState('');
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const timerRef = React.useRef(null);

    const dispatch = useDispatch();
    const { classSchedules, classStudents, present, subjectList, facultyList, classSchedulePagination } = useSelector(state => state.schedule);
    const { chapterList, topicsList } = useSelector(state => state.manageContent);

    useEffect(()=> {
        dispatch(getClassSchedules('', '', '', '', '', '', 1, 10));
        dispatch(getSubjects());
        dispatch(getFacultyList());
    },[])

    const openFilter = () => {
        setIsOpenFilter(!isOpenFilter)
    }

    const handleClose = () => {
        setIsOpenFilter(false)
    }

    const searchSchedule = (val) => {
        clearTimeout(timerRef.current);
        setScheduleSearch(val);
        timerRef.current = setTimeout(() => {
            dispatch(getClassSchedules(val, subjectId, chapterId, topicId, selectedStatus, facultyId, page, size));
        }, 500);
    }

    const searchStudent = (val) => {
        clearTimeout(timerRef.current);
        setStudentSearch(val);
        timerRef.current = setTimeout(() => {
            dispatch(getClassStudents(classId, val));
        }, 500);
    }

    const handleMarkAttendance = (schedule) => {
        setIsMark(true);
        setClassId(schedule._id)
        dispatch(getClassStudents(schedule._id, ''));
    }

    const selectTopic = async (selectedOption,) => {
        setSelectedTopic(selectedOption);
        setTopicId(selectedOption.value);
    }

    const selectChapter = async (selectedOption,) => {
        setSelectedChapter(selectedOption);
        setChapterId(selectedOption.value);
        dispatch(getTopics(selectedOption.value));
        setTopicId('')
        setSelectedTopic(null)
    }

    const selectSubject = async (selectedOption,) => {
        setSelectedSubject(selectedOption);
        setSubjectId(selectedOption.value);
        await dispatch(getChapters(selectedOption.value));
        setFacultyId('')
        setSelectedFaculty(null)
        setTopicId('')
        setSelectedTopic(null)
        setChapterId('')
        setSelectedChapter(null)
    }

    const selectFaculty = async (selectedOption,) => {
        setSelectedFaculty(selectedOption);
        setFacultyId(selectedOption.value);
    }

    const clearFilters = () => {
        setSelectedStatus('');
        setSelectedSubject(null);
        setSelectedChapter(null);
        setSelectedTopic(null);
        setSelectedFaculty(null);
        setSubjectId('');
        setChapterId('');
        setTopicId('');
        setFacultyId('');
        dispatch(getClassSchedules('', '', '', '', '', '', 1, 10));
    }

    const ApplyFilters = () => {
        setIsOpenFilter(false);
        dispatch(getClassSchedules(scheduleSearch, subjectId, chapterId, topicId, selectedStatus, facultyId, page, size));
    }

    const onFilterClick = (value) => {
        if (value === 'subject') {
            setSelectedSubject(null);
            setSubjectId('');
            setChapterId('');
            setTopicId('');
            dispatch(getClassSchedules(scheduleSearch, '', '', '', selectedStatus, facultyId, page, size));
        }
        else if (value === 'chapter') {
            setSelectedChapter(null);
            setChapterId('');
            setTopicId('');
            dispatch(getClassSchedules(scheduleSearch, subjectId, '', '', selectedStatus, facultyId, page, size));
        }
        else if (value === 'topic') {
            setSelectedTopic(null);
            setTopicId('');
            dispatch(getClassSchedules(scheduleSearch, subjectId, chapterId, '', selectedStatus, facultyId, page, size));
        }
        else if (value === 'faculty') {
            setSelectedFaculty(null);
            setFacultyId('');
            dispatch(getClassSchedules(scheduleSearch, subjectId, chapterId, topicId, selectedStatus, '', page, size));
        }
    }

    const nextPage = () => {
        setPage(page + 1);
        dispatch(getClassSchedules(scheduleSearch, subjectId, chapterId, topicId, selectedStatus, facultyId, page + 1, size));
    }

    const prevPage = () => {
        setPage(page - 1);
        dispatch(getClassSchedules(scheduleSearch, subjectId, chapterId, topicId, selectedStatus, facultyId, page - 1, size));
    }

    const changeSize = (size) => {
        setSize(size);
        dispatch(getClassSchedules(scheduleSearch, subjectId, chapterId, topicId, selectedStatus, facultyId, page, size));
    }

    const saveAttendance = async () => {
        // if (classStudents.filter(el => el.present).length < 1) {
        //     setIswarn(true);
        // }
        // else {
            let obj = {
                class_id: classId,
                data: classStudents && classStudents.map(el => [{ student_id: el._id, present: el.present }][0])
            }
            await dispatch(markAttendance(obj));
        // }
    }

    const back = () => {
        setIsMark(false);
        setIswarn(false);
    }

    return (
        <div>
        {!isMark ?
        <div className='attendance-container'>
            <h3>Attendance</h3>
            <div className='schedule-header'>
                <div className="has-search"  >
                    <span className="form-control-feedback">
                        <img src="/images/search1.svg" width="14" alt='' />
                    </span>
                    <input type='search' name='student' placeholder='' value={scheduleSearch} id='search' onChange={(e) => searchSchedule(e.target.value)} autoComplete='off' className='form-control' />
                </div>
                <div className='d-flex align-items-center cursor-pointer' onClick={openFilter}>
                    <img src='/images/filter-icon.svg' alt='' /> &nbsp;<p>Filters</p>
                </div>
            </div>
            <div className="table-admin" 
            style={{ marginTop: classSchedules?.length === 0 ? -43 : -60 }}
            >
                <Table responsive style={{ overflow: 'hidden' }}>
                    <thead>
                        <tr className="header-table">
                            <th style={{ width: '15%' }}>Title</th>
                            <th style={{ width: '15%' }}>Subject</th>
                            <th style={{ width: '15%' }}>Chapter</th>
                            <th style={{ width: '15%' }}>Topic</th>
                            <th style={{ width: '10%' }}>Date & Time</th>
                            <th style={{ width: '10%' }}>Faculty</th>
                            <th style={{ width: '10%' }}>Section / Students</th>
                            <th style={{ width: '10%' }}>Mark Attendance</th>
                        </tr>
                        <hr />
                    </thead>
                    <div className='showing-results' >
                        <p>{selectedSubject !== null || selectedChapter !== null || selectedTopic !== null || selectedFaculty !== null ?
                            <span onClick={() => clearFilters('student')}>CLEAR FILTERS</span> : null}</p>
                        {
                            selectedSubject !== null || selectedChapter !== null || selectedTopic !== null || selectedFaculty !== null ?
                                <div className='clear'>
                                    <div className='select-list'>
                                        <ul>
                                            {selectedSubject !== null ? <li >
                                                {selectedSubject !== undefined && (selectedSubject?.label)}
                                                <img src="/images/close1.svg" alt='' onClick={() => onFilterClick('subject')} />
                                            </li> : null}
                                            {selectedChapter !== null ? <li >
                                                {selectedChapter !== undefined && selectedChapter?.label}
                                                <img src="/images/close1.svg" alt='' onClick={() => onFilterClick('chapter')} />
                                            </li> : null}
                                            {selectedTopic !== null ? <li>
                                                {selectedTopic !== undefined && selectedTopic?.label}
                                                <img src="/images/close1.svg" alt='' onClick={() => onFilterClick('topic')} />
                                            </li> : null}
                                            {selectedFaculty !== null ? <li>
                                                {selectedFaculty !== undefined && selectedFaculty?.label}
                                                <img src="/images/close1.svg" alt='' onClick={() => onFilterClick('faculty')} />
                                            </li> : null}
                                        </ul>
                                    </div>
                                </div>
                            : null
                        }
                    </div>
                    <tbody className="table-body" >
                        {
                            (classSchedules !== "" && classSchedules !== undefined && classSchedules.length > 0 ?
                                classSchedules.map((schedule, i) => {
                                    return (
                                        <tr key={i} 
                                        style={{ borderTop: i === 0 ? ( selectedSubject !== null || selectedChapter !== null || selectedTopic !== null || selectedFaculty !== null ) ? '65px solid #F7F7FA' : '15px solid #F7F7FA' : null }}
                                        >
                                            <td style={{ width: '15%' }}>{schedule?.title}</td>
                                            <td style={{ width: '15%' }}>{schedule?.subject?.name}</td>
                                            <td style={{ width: '15%' }}>{schedule?.chapter?.name}</td>
                                            <td style={{ width: '15%' }}>{schedule?.topic?.name}</td>
                                            <td style={{ width: '10%' }} className='text-center'>
                                                {convertDate(schedule?.date)}
                                                <br />
                                                {formatTimeTo12Hour(schedule?.from)} - {formatTimeTo12Hour(schedule?.to)}
                                            </td>
                                            <td style={{ width: '10%' }}>{schedule.faculty ? schedule.faculty.firstname + ' ' + schedule.faculty.lastname : '-' }</td>
                                            <td style={{ width: '10%' }} className='text-center'>{schedule?.sections?.map(el => el.name).join(', ') || schedule?.students}</td>
                                            <td style={{ width: '10%', cursor: 'pointer' }} 
                                                className='text-center'
                                                onClick={() => handleMarkAttendance(schedule)}
                                            >
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    style={{
                                                        padding: '5px 10px',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        opacity: 0.7
                                                    }}
                                                >
                                                    Mark
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                                :
                                <tr style={{ borderTop: '35px solid #F7F7FA' }}>
                                    <td colSpan={2}>
                                        <div className='empty-list'>
                                            <img src='/images/empty.png' alt='' />
                                        </div>
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </div>
            {
                classSchedulePagination !== undefined && classSchedulePagination.totalPages > 1 && 
                <div className='d-flex align-items-center justify-content-between' style={{ marginTop: (classSchedules?.length < 1 ? 315 : 25) }}>
                    <div className='attendance-pagination' 
                        style={{ marginTop: (classSchedules?.length < 1 ? 315 : 25) }}>
                        {
                            page === 1 ?
                                <img src='/images/page_prev_disable.svg' alt='' />
                                : <img src='/images/page_prev_active.svg' onClick={prevPage} alt='' />
                        }
                        &nbsp;&nbsp;
                        <div>Page&nbsp;&nbsp; <input value={page} readOnly />&nbsp;of {classSchedulePagination?.totalPages}</div>&nbsp;
                        {
                            page === classSchedulePagination?.totalPages ?
                                <img src='/images/page_next_disable.svg' alt='' /> :
                                <img src='/images/page_next_active.svg' onClick={nextPage} alt='' />
                        }
                    </div>
                    <div className='d-flex align-items-center justify-content-end' style={{ width: classSchedulePagination !== undefined && classSchedulePagination.totalPages > 1 ? '20%' : '100%' }}>
                        <select style={{ width: '20%' }} className='form-control' value={size} onChange={(e) => changeSize(e.target.value)}>
                            <option>10</option>
                            <option>20</option>
                            <option>30</option>
                            <option>40</option>
                        </select> &nbsp;
                        <p>Items per page</p>
                    </div>
                </div>
            }
        </div>:
            <div className='attendance-planning' style={{ minHeight: '' }}>
                <div className='add-header p-2' style={{ width: '100%' }}>
                    <div className='d-flex align-items-center'>
                        { <img src='/images/back-arrow.svg' onClick={() => back() } alt='' width={20} height={20} />}
                        <div style={{ marginLeft: 20 }}>
                            <h2>Attendance Details</h2>
                            {/* <p className='text-left'>{convertDate(details?.date)} | {details?.start} - {details?.end} </p> */}
                        </div>
                    </div>
                    <div className='d-flex align-items-center'>
                        <h1>{present || 0}/{classStudents?.length}</h1>&nbsp;&nbsp;
                        <button className='save-btn mt-0 ml-4' style={{ color: "#fff", border: 0 }} onClick={() => saveAttendance()}>Save</button>
                    </div>
                </div>
                <div className='search-bar d-flex mt-1'>
                    <div className="has-search" style={{ width: '45%', position: 'relative' }}>
                        <input 
                            type="text" 
                            className="form-control" 
                            aria-describedby="emailHelp" 
                            placeholder="Search for Student" 
                            onChange={(e) => searchStudent(e.target.value)}
                            style={{ paddingLeft: '35px' }} 
                            value={studentSearch}
                        />
                        <span 
                            className="form-control-feedback" 
                            style={{ 
                                position: 'absolute',
                                left: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                pointerEvents: 'none'
                            }}
                        >
                            <img src="/images/search.svg" alt='' />
                        </span>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                        <div 
                            className='present-btn'
                            onClick={() => {
                                setSave(true);
                                dispatch(markPresent());
                            }}
                        >
                            Mark all as present
                        </div>
                        <div 
                            className='absent-btn'
                            onClick={() => {
                                setSave(true);
                                dispatch(markAbsent());
                            }}
                        >
                            Mark all as absent
                        </div>
                    </div>
                </div>
                <div>
                    {classStudents !== undefined && classStudents?.length ?
                        <ul className='schedule-list d-flex flex-wrap' >
                            {
                                classStudents !== undefined && classStudents.map((el, index) => {
                                    return (
                                        <li key={index} className='d-flex' style={{ width: '33%', marginTop: 5 }} >
                                            <div className='marks-box d-flex w-100' >
                                                <p style={{ width: '50%' }}>{el.firstname} {el.lastname}</p>
                                                <div className='d-flex align-items-center justify-content-end' style={{ width: '45%', marginRight: 12 }} >
                                                    <Switch
                                                        width={32}
                                                        height={18}
                                                        uncheckedIcon={false}
                                                        checkedIcon={false}
                                                        onColor='#00B24B'
                                                        onChange={() => {
                                                            setSave(true);
                                                            dispatch(changeStatus(el.present, el._id));
                                                        }}
                                                        checked={el.present ? true : false} />&nbsp;&nbsp;&nbsp;
                                                    {el.present ? <span style={{ width: 45, textAlign: 'left' }}>Present</span> :
                                                        <div className='d-flex flex-column align-items-center'>
                                                            <span style={{ width: 45, textAlign: 'left' }}>Absent</span>
                                                            <select className='form-control' style={{ width: '100%' }} value={el.leave} onChange={(e) => { dispatch(changeLeaveStatus(e.target.value, el.student_id)) }}  >
                                                                <option hidden>Leave</option>
                                                                <option value='medical'>Medical</option>
                                                                <option value='exceptional'>EL</option>
                                                            </select>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </li>
                                    )
                                })
                            }

                        </ul>
                        :
                        <div className='empty-list'>
                            <img src='/images/empty.png' alt='' />
                            <p>No students added to this Class</p>
                        </div>
                    }

                </div>
            </div>
            }

            <Modal
                show={isWarn}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"confirm-modal"}
            >
                <div className="p-3 text-center">
                    <h1>Oops! You can't save attendance because at least one present mark is essential. </h1>
                    <div className="text-center d-flex flex-column align-items-center p-2 ">
                        <p className="text-capitalize"></p>
                    </div>
                    <div className="save-btn mt-0 text-center">
                        <button onClick={() => setIswarn(false)}>Ok</button>
                    </div>
                </div>
            </Modal>
            <Modal show={isOpenFilter} size='lg' centered aria-labelledby="contained-modal-title-vcenter" dialogClassName={"filter-modal"}>
                <Modal.Body style={{ paddingTop: 20, paddingLeft: 70, paddingRight: 70, paddingBottom: 30 }}>
                    <div className="filter">
                        <h1>Filter Attendance</h1>
                        <div onClick={handleClose} className='close-upload'><img src='/images/close1.svg' alt='' /></div>
                        <div>
                            <div className='form-group mt-2'>
                                <label>Subject</label>
                                <Select
                                    options={subjectList || []}
                                    value={selectedSubject}
                                    onChange={selectSubject}
                                    getOptionLabel={option => option.label}
                                    getOptionValue={option => option.value}
                                    placeholder="Select subjects..."
                                    className="basic-select"
                                    classNamePrefix="select"
                                />
                            </div>
                            <div className='form-group mt-2'>
                                <label>Chapter</label>
                                <Select
                                    options={chapterList.map(chapter => ({
                                        value: chapter._id,
                                        label: chapter.name
                                    })) || []}
                                    value={selectedChapter}
                                    onChange={selectChapter}
                                    getOptionLabel={option => option.label}
                                    getOptionValue={option => option.value}
                                    placeholder="Select Chapter..."
                                    className="basic-select"
                                    classNamePrefix="select"
                                    disabled={!selectedSubject}
                                />
                            </div>
                            <div className='form-group mt-2'>
                                <label>Topic</label>
                                <Select
                                    options={topicsList.map(topic => ({
                                        value: topic._id,
                                        label: topic.name
                                    })) || []}
                                    value={selectedTopic}
                                    onChange={selectTopic}
                                    getOptionLabel={option => option.label}
                                    getOptionValue={option => option.value}
                                    placeholder="Select Topic..."
                                    className="basic-select"
                                    classNamePrefix="select"
                                    disabled={!selectedChapter}
                                />
                            </div>
                            <div className='form-group mt-2'>
                                <label>Faculty</label>
                                <Select
                                    options={facultyList && facultyList.map(faculty => ({
                                        value: faculty._id,
                                        label: faculty.firstname + ' ' + faculty.lastname
                                    })) || []}
                                    value={selectedFaculty}
                                    onChange={selectFaculty}
                                    getOptionLabel={option => option.label}
                                    getOptionValue={option => option.value}
                                    placeholder="Select faculty..."
                                    className="basic-select"
                                    classNamePrefix="select"
                                />
                            </div>
                            <div className='filter-btn '>
                                <div>
                                    <button className='position-relative' onClick={ApplyFilters}>Apply Filters</button>
                                    &nbsp;&nbsp;
                                    <button className='position-relative' onClick={handleClose}>Cancel</button>
                                </div>
                                <p className='position-relative' onClick={clearFilters}>Clear Filters</p>
                            </div>
                        </div>            
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Attendance;